.downloadButton {
    align-self: end;
}
